import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { useNotification } from 'utils/hooks/useNotification';
import { selectedRowsAtom } from '../atoms';
import { resubmitJob } from './api';

export const useResubmitOrchestrations = () => {
  const selectedRows = useAtomValue(selectedRowsAtom);
  const queryClient = useQueryClient();
  const { showSuccessNotification, showErrorNotification } = useNotification();

  const { mutate: resubmitOrchestrations, isPending } = useMutation({
    mutationFn: async () => {
      const resubmitPromises = selectedRows.map((row) =>
        resubmitJob(row.jobId)
      );
      await Promise.all(resubmitPromises);
    },
    onError: (error) => {
      const message =
        error instanceof Error ? error.message : 'An unknown error occurred';
      showErrorNotification(`Failed to resubmit orchestrations: ${message}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      showSuccessNotification('Orchestrations resubmitted successfully');
    },
  });

  const handleResubmitOrchestrations = () => {
    if (selectedRows.length === 0) {
      return;
    }
    resubmitOrchestrations();
  };

  const canResubmitOrchestrations =
    selectedRows.length > 0 &&
    selectedRows.every((row) => row.workflow.supportResubmit);

  const resubmitTooltip = canResubmitOrchestrations
    ? 'Resubmit orchestrations'
    : 'Select one or more rows with support resubmit orchestrations to perform this action';

  return {
    canResubmitOrchestrations,
    handleResubmitOrchestrations,
    isPending,
    resubmitTooltip,
  };
};
